module.exports = __webpack_public_path__ + "img/frameCardZero.02c3491b.png";